module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_GYY_3X.1af9eef5.tom";